<template>
    <section class="space-y-4">
        <div class="space-y-1">
            <h3 class="text-text-light dark:text-text-dark text-sm font-semibold">
                {{ trans('maintainers.form.business_contacts.label') }}
            </h3>
        </div>

        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
            <article
                v-for="contact in businessContacts"
                :key="contact.id ?? contact.email ?? contact.phone ?? contact.name"
                class="border-border-light dark:border-border-dark rounded-lg border bg-blue-50/30 p-4 dark:bg-blue-900/10"
            >
                <div class="mb-2 flex items-start justify-between gap-3">
                    <div class="min-w-0">
                        <h4 class="text-text-light dark:text-text-dark truncate text-sm font-medium">
                            {{ contact.name || trans('stakeholders.form.contact_name.label') }}
                        </h4>
                        <span class="text-[10px] font-bold tracking-wider text-primary uppercase">
                            {{ trans('maintainers.form.business_contacts.label') }}
                        </span>
                    </div>
                    <button
                        class="text-subtext-light dark:text-subtext-dark transition-colors hover:text-primary"
                        type="button"
                        @click="$emit('edit')"
                    >
                        <icon name="cil-pencil" />
                    </button>
                </div>

                <div class="text-subtext-light dark:text-subtext-dark space-y-1 text-xs">
                    <p v-if="contact.email" class="flex items-center gap-2">
                        <icon class="text-sm text-primary" name="cil-envelope-closed" />
                        <span class="truncate">{{ contact.email }}</span>
                    </p>
                    <p v-if="contact.phone" class="flex items-center gap-2">
                        <icon class="text-sm text-primary" name="cil-phone" />
                        <span class="truncate">{{ contact.phone }}</span>
                    </p>
                </div>
            </article>

            <button
                class="border-border-light text-subtext-light dark:border-border-dark dark:text-subtext-dark flex min-h-36 flex-col items-center justify-center rounded-lg border-2 border-dashed p-4 transition-colors hover:border-primary hover:text-primary"
                type="button"
                @click="$emit('add')"
            >
                <icon class="mb-1" name="cil-user-follow" size="xl" />
                <span class="text-xs font-medium">
                    {{ addBusinessContactLabel }}
                </span>
            </button>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue';
import { trans } from '@/mixins/i18n';

defineEmits(['add', 'edit']);

defineProps({
    businessContacts: {
        type: Array,
        default: () => [],
    },
});

const addBusinessContactLabel = computed(() => `${trans('general.action.add')} ${trans('maintainers.form.business_contacts.label')}`);
</script>
